<template>
  <div>
    <div class="text-left">
      <div class="section-icon">💴</div>
    </div>

    <!-- block -->
    <div class="block mt-4">
      <h1>How do we compensate?</h1>
      <p class="lead mt-4">
        I am looking for a role where my skills will be <b>appreciated</b>, my
        personal/family time <b>respected</b> and my work
        <b>fairly</b> compensated.
      </p>
      <p class="mt-4">
        My current freelance hour price range is 45 EUR + VAT. Flat monthly fee
        arrangement is also possible if that is of interest.
      </p>
    </div>
    <!-- ./ block -->
  </div>
</template>

<script>
export default {
  name: 'Compensation'
}
</script>

<style></style>
